import { LRUCache } from "lru-cache";

const cache = new LRUCache({
    max: 1000, // max number of items that remain in the cache
    ttl: 60 * 60 * 1000, // one hour in milliseconds
});

export default cache
